var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('intermission-form',{attrs:{"id":_vm.id,"type":"intermission","plural":"intermissions"},model:{value:(_vm.intermission),callback:function ($$v) {_vm.intermission=$$v},expression:"intermission"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }